import ChannelObject from "../../../../src/mdx/api/schema/channel-object.mdx";
import * as React from 'react';
export default {
  ChannelObject,
  React
};